exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toaster{position:fixed;bottom:20px;left:30px;z-index:99999;transform:translateY(200%);transition:transform .4s cubic-bezier(.59,-.55,.52,1.49)}.toaster.active{transform:translateY(0)}.toaster.success .toaster__inner{background:#00c6b5!important}.toaster__inner{padding:10px 40px;background:#f03636;border-radius:2px;color:#fff;text-align:center;min-width:150px;letter-spacing:.1em;font-weight:700}", ""]);

// exports
